/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForVulnerabilitiesAzure extends models.GovernanceConfigurationBaseForVulnerabilities {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForVulnerabilitiesAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForVulnerabilitiesAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForVulnerabilitiesAzure>): GovernanceConfigurationForVulnerabilitiesAzure {
        let obj = Object.assign(new GovernanceConfigurationForVulnerabilitiesAzure(), model);
        GovernanceConfigurationForVulnerabilitiesAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForVulnerabilitiesAzure>): GovernanceConfigurationForVulnerabilitiesAzure {
        if (!model) return null;
        return GovernanceConfigurationForVulnerabilitiesAzure.newInstance(<GovernanceConfigurationForVulnerabilitiesAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForVulnerabilitiesAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForVulnerabilitiesAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForVulnerabilitiesAzure): boolean {
        if (models.GovernanceConfigurationBaseForVulnerabilities.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForVulnerabilitiesAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
